import type { ListBuilderList } from '../../../types';
import {
	createItemColumn,
	createItemNumberColumn,
	createRecommendationLevelColumn,
	createScoreColumn,
} from '../columns';

/**
 * Recommended Items list configuration
 * Shows AI-recommended items based on client purchasing patterns and similar clients
 */
export const recommendedList: ListBuilderList = {
	id: 'client-item-recommended',
	cacheTTL: 600000,
	name: 'Recommended',
	type: 'custom',
	active: true,
	filterRules: {
		listType: { defaultValue: 'recommended' },
	},
	columns: [
		createItemColumn(),
		createItemNumberColumn(),
		createRecommendationLevelColumn(),
		createScoreColumn(
			'sameCategoryScore',
			'sameCategoryStars',
			'sameCategoryScore',
			'sameCategoryPercent',
			'{sameCategoryScore} items ({sameCategoryPercent}%)',
			'Category Match',
		),
		createScoreColumn(
			'sameBusinessTypeScore',
			'sameBusinessTypeStars',
			'sameBusinessTypeScore',
			'sameBusinessTypePercent',
			'{sameBusinessTypeScore} customers ({sameBusinessTypePercent}%)',
			'Business Match',
		),
		createScoreColumn(
			'sameGeographyScore',
			'sameGeographyStars',
			'sameGeographyScore',
			'sameGeographyPercent',
			'{sameGeographyScore} customers ({sameGeographyPercent}%)',
			'Geography Match',
		),
		createScoreColumn(
			'lookalikeScore',
			'lookalikeStars',
			'lookalikeScore',
			'lookalikePercent',
			'{lookalikeScore} customers ({lookalikePercent}%)',
			'Similar Clients',
		),
		createScoreColumn(
			'generalPopularityScore',
			'popularityStars',
			'generalPopularityScore',
			'popularityPercent',
			'{generalPopularityScore} customers ({popularityPercent}%)',
			'Overall Popularity',
		),
	],
	searchEnabled: true,
	searchPlaceholder: 'Search recommended items...',
	sortOrder: 3,
};
